// src/i18n/config.js
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// Import translation files
import enTranslations from './locales/en.json';
import esTranslations from './locales/es.json';
import frTranslations from './locales/fr.json';
import deTranslations from './locales/de.json';
import zhTranslations from './locales/zh.json';
import swTranslations from './locales/sw.json';
import amTranslations from './locales/am.json';
import haTranslations from './locales/ha.json';
import yoTranslations from './locales/yo.json';
import igTranslations from './locales/ig.json';
import zuTranslations from './locales/zu.json';
import xhTranslations from './locales/xh.json';
import afTranslations from './locales/af.json';
import arTranslations from './locales/ar.json';
import soTranslations from './locales/so.json';
import rwTranslations from './locales/rw.json';
import akTranslations from './locales/ak.json';
import ffTranslations from './locales/ff.json';
import lnTranslations from './locales/ln.json';
import mgTranslations from './locales/mg.json';
import omTranslations from './locales/om.json';
import tiTranslations from './locales/ti.json';
import tnTranslations from './locales/tn.json';
import veTranslations from './locales/ve.json';
import woTranslations from './locales/wo.json';

const resources = {
  en: { translation: enTranslations },
  es: { translation: esTranslations },
  fr: { translation: frTranslations },
  de: { translation: deTranslations },
  zh: { translation: zhTranslations },
  sw: { translation: swTranslations },
  am: { translation: amTranslations },
  ha: { translation: haTranslations },
  yo: { translation: yoTranslations },
  ig: { translation: igTranslations },
  zu: { translation: zuTranslations },
  xh: { translation: xhTranslations },
  af: { translation: afTranslations },
  ar: { translation: arTranslations },
  so: { translation: soTranslations },
  rw: { translation: rwTranslations },
  ak: { translation: akTranslations },
  ff: { translation: ffTranslations },
  ln: { translation: lnTranslations },
  mg: { translation: mgTranslations },
  om: { translation: omTranslations },
  ti: { translation: tiTranslations },
  tn: { translation: tnTranslations },
  ve: { translation: veTranslations },
  wo: { translation: woTranslations },
};

// Get initial language from localStorage or default to 'en'
const getInitialLanguage = () => {
  try {
    const stored = localStorage.getItem('userLanguage');
    if (stored && resources[stored]) {
      return stored;
    }
  } catch (e) {
    // Ignore errors
  }
  return 'en';
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    lng: getInitialLanguage(), // Set initial language explicitly
    fallbackLng: 'en',
    debug: true, // Enable debug to see what's happening
    interpolation: {
      escapeValue: false, // React already escapes values
    },
    react: {
      useSuspense: false, // Disable suspense to avoid issues
    },
    detection: {
      order: ['localStorage', 'navigator'],
      caches: ['localStorage'],
      lookupLocalStorage: 'userLanguage',
    },
  });

export default i18n;

